// extracted by mini-css-extract-plugin
export var fileUpload = "_ip-1";
export var modalButton = "_ip-0";